import {
  computed,
  inject,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { DEFAULT_HEADER, IHeader } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { AppConfigService } from '../../app-config.service';
import { HeaderGateway } from './header.gateway';

@Injectable({
  providedIn: 'root',
})
export class HeaderStore {
  private readonly gateway: HeaderGateway = new HeaderGateway();
  private readonly configService: AppConfigService = inject(AppConfigService);

  #headerResource: ResourceRef<IApiResponse<IHeader> | undefined> = resource({
    loader: (): Promise<IApiResponse<IHeader>> => {
      return firstValueFrom(this.gateway.get());
    },
  });

  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#headerResource.isLoading()
  );
  readonly header: Signal<IHeader> = computed((): IHeader => {
    return this.#headerResource.hasValue()
      ? (this.#headerResource.value()?.data ?? DEFAULT_HEADER)
      : DEFAULT_HEADER;
  });

  reload(): void {
    this.#headerResource.reload();
  }

  updateHeader(query: IHeader): void {
    this.#headerResource.update((): IApiResponse<IHeader> => {
      return {
        data: query,
      };
    });
  }

  save(query: IHeader): void {
    firstValueFrom(this.gateway.save(query)).then(
      (result: IApiResponse<IHeader>): void => {
        if (result && result.data) {
          this.updateHeader(result.data);
        }
      }
    );
  }

  logoPath: Signal<string> = computed((): string => {
    return this.configService.get().general.cmsUrl + '/header/logo-image';
  });
  rightPath: Signal<string> = computed((): string => {
    return this.configService.get().general.cmsUrl + '/header/right-image';
  });
  leftPath: Signal<string> = computed((): string => {
    return this.configService.get().general.cmsUrl + '/header/left-image';
  });
}
